import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-4I-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 40.71 36.13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-4I-logo_svg__cls-1{fill:#007b38}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M32.7 10.8c-1.74.01-3.95 1.59-6.23 3.7l.05-.04c3.57-2.51 7.96-3.85 14.19-2.87-17.93-1.81-3.42 14.85-38.04 24.54 10.18-4.35 14.36-12.52 18.09-18.56 3.4-5.51 6.49-9.24 11.94-6.77Z",
      class: "svg-4I-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M0 0c2.43 7.11 11.42 7.38 15.48 10.85 4.07 3.47 4.76 8.23.21 13.75C17.84 19.37 1.38 11.67 0 0",
      class: "svg-4I-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "4I-logo"}) } }